const SareeProduct =({product}) => {
        
     
      console.log("eeeeeeeeeee1",product)

    return (
        <>
        <td className='title'>
            {product.name}
            <span>{product['subcategory']['name'] === "Sarees" && "SKU: " + product.variants[0].sku}</span>
            <span>{product['subcategory']['name'] + ' > '}  {product['subcategory']['name']}</span>
        </td>
        <td> <h5 className="price">₹{Math.round(product.variants[0].price)} <span className='strikedPrice'>₹{Math.round(product.variants[0].actual_price)}</span></h5> </td>
        <td>
            <div className="product-size m-b-10">
                { <span className={ ( product.variants[0].out_of_stock ? ' bg-danger ' : ' bg-success ') + " badge  m-0"}>{product.variants[0].out_of_stock ?   'Out of Stock' : 'In Stock'}</span>}  
            </div>
        </td>
        <td>
            <div className="product-size m-b-10">
                { <span className={ ( product.variants[0].display_online ? ' bg-success ' : ' bg-danger ') + " badge  m-0"}>{product.variants[0].display_online ?   'Online' : 'Offline'}</span>}  
            </div>
        </td>
        <td></td>
        <td></td>
                           
    </>
    )
}


export default SareeProduct;